import type { ChatSessionsApiResponse } from 'core_main/api/sessions/types';
import { PUBNUB_SUBSCRIBE_OPERATION } from 'core_main/pubnub/constants';
import type { ConversationCallbackResponse } from '../types';

export const RETRY_MAX = 3;

export const createConversationCallbackResponse = (
  response: ChatSessionsApiResponse,
): ConversationCallbackResponse => {
  const { id: conversationId } = response.data;
  const { createdAt, lockedAt, isInAssistantMode } = response.data.attributes;

  return {
    conversationId,
    createdAt,
    ended: !!lockedAt,
    isInAssistantMode,
  };
};

export const createNewConversationStatusEventListener = (
  { conversationChannels },
  cb,
) => {
  return (statusEvent) => {
    const { operation, affectedChannels, error, category } = statusEvent;
    if (operation === PUBNUB_SUBSCRIBE_OPERATION) {
      const includedChannels = conversationChannels.filter((channel) =>
        affectedChannels?.includes(channel),
      );
      if (includedChannels.length === conversationChannels.length || error) {
        cb(null, error ? category : null);
      }
    }
  };
};
